import React, { Suspense, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import ReportModal from "./Modals/ReportModal";
import Header from "../layout/Header";
import { Footer } from "../layout/Footer";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useEffect } from "react";
import { getUrl, getUserData, setUserData } from "../../utills/defaultValues";
import swal from "sweetalert";
import SuccessModal from "./Modals/SuccessModal";
import { storeContact } from "../../actions/scanActions";
import FormLoader from "../loader/FormLoader";

const AuditReport = ({ storeContact, contactDetails }) => {
  const location = useLocation();
  const scanData = location.state?.data;
  const history = useHistory();

  const message =
    "Check out this awesome website to see vulnerabilities in your website!";
  const currentUrl = window.location.origin;

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ header: "", content: "" });
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [buttonFlag, setButtonFlag] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (getUrl() === null || !scanData?.url) {
      history.push("/");
    }

    const handlePrintScreen = (e) => {
      e.preventDefault();
      navigator.clipboard.writeText("");
      // alert("Screenshots are disabled!");
    };

    document.addEventListener("keyup", (e) => {
      if (e.key === "PrintScreen") {
        handlePrintScreen(e);
      }
    });

    return () => {
      document.removeEventListener("keyup", handlePrintScreen);
    };
  }, []);

  const handleModal = (data) => {
    if (!getUserData() && getUserData() === null) {
      setShowModal(true);
      setButtonFlag(data);
    } else {
      setButtonFlag(data);
      if (data === "report") {
        if (getUserData()?.btn_flag === "report") {
          setModalData({
            header: "Thank you!",
            content: "Scan report is already sent to your email!",
            status: "success",
          });
          handleSuccessModal();
          // swal("Thank you!", "Scan report is already sent in your email!", "success");
        } else {
          setLoading(true);

          const params = {
            lastid: getUserData()?.lastid,
            name: getUserData()?.name,
            email: getUserData()?.email,
            mobile: getUserData()?.mobile,
            designation: getUserData()?.designation,
            website: getUserData()?.website,
            company_name: getUserData()?.company_name,
            country: getUserData()?.country,
            btn_flag: "report",
            user_id: getUserData()?.user_id,
          };
          setUserData(params);

          storeContact(params, setLoading);
        }
      } else if (data === "awesome") {
        window.open(
          `https://web.whatsapp.com/send?text=${encodeURIComponent(
            `${message} ${currentUrl}`
          )}`,
          "_blank"
        );
      } else {
        setModalData({
          header: "Thank you!",
          content: "Our team will contact you soon!",
          status: "success",
        });
        handleSuccessModal();
        // swal("Thank you!", "Our team will contact you soon!", "success");
      }
    }
  };

  const disableRightClick = (e) => {
    e.preventDefault();
    // alert("Right-click is disabled!");
  };

  const disableCopyPaste = (e) => {
    e.preventDefault();
    // alert("Copy-pasting is disabled!");
  };

  const handleSuccessModal = () => {
    setShowSuccessModal(true);
  };

  return (
    <div
      className="site-main height-overflow-css"
      onContextMenu={disableRightClick}
      onCopy={disableCopyPaste}
      onCut={disableCopyPaste}
      onPaste={disableCopyPaste}
    >
      <Header />
      <div className="flex-content-css">
        <div className="audit-report-mt ar-line-height">
          <div className="container-xl padding-css">
            {scanData ? (
              <>
                <div className="row align-items-center d-flex">
                  <div className="col-auto mb-4">
                    <div id="contentDisplay" className="content-display">
                      Audit report for <strong>{scanData?.url}</strong>
                    </div>
                  </div>
                  <div className="col-auto mb-4">
                    <Button
                      type="button"
                      className="vs-button-css btn-success"
                      size="md"
                      onClick={() => handleModal("report")}
                    >
                      {loading === true &&
                      getUserData()?.btn_flag === "report" ? (
                        <>
                          <FormLoader />
                          <span style={{ marginLeft: "8px" }}>
                            Please wait...
                          </span>
                        </>
                      ) : (
                        "Get your report"
                      )}
                    </Button>
                  </div>
                  <div className="col-auto mb-4 ms-auto">
                    <Button
                      variant="secondary"
                      type="button"
                      className="vs-button-css"
                      size="md"
                      onClick={() => history.push("/")}
                    >
                      Back to scan
                    </Button>
                  </div>
                  <div className="col-auto mb-4 ms-auto">
                    <Button
                      variant="primary"
                      type="button"
                      className="vs-button-css"
                      size="md"
                      onClick={() => handleModal("fix-wish")}
                    >
                      Fix this issue
                    </Button>
                  </div>
                  <div className="col-auto mb-4 ms-auto">
                    <Button
                      type="button"
                      className="vs-button-css awsome-btn"
                      size="md"
                      onClick={() => handleModal("awesome")}
                    >
                      Share this url
                    </Button>
                  </div>
                </div>
                <Row className="align-items-start display-none-style">
                  <Col className="mb-4">
                    <h1 className="heading-margin audit-title-font mb-3">
                      Audit Report
                    </h1>
                  </Col>
                </Row>
                <Row className="align-items-start flex-wrap">
                  <Col lg="5" md="6" className="mb-4">
                    <h1 className="heading-margin audit-title-font mb-3 display-block-style">
                      Audit Report
                    </h1>
                    <h3 className="heading-margin mt-2 heading-font">
                      Vulnerability List
                    </h3>
                    <ul className="list-css">
                      {scanData?.headers.map((header, index) => (
                        <li key={index} className="mb-2">
                          {header.name} -------------{" "}
                          {header.status === "Found" ? (
                            <span className="text-danger">(Found risky)</span>
                          ) : (
                            <span className="text-success">(OK)</span>
                          )}
                        </li>
                      ))}
                    </ul>
                  </Col>
                  <Col lg="5" md="6" className="mb-4">
                    <div id="screenshotContainer" className="screenshot-css">
                      {scanData?.img_url ? (
                        <img
                          src={scanData?.img_url}
                          alt="Screenshot"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "300px",
                            objectFit: "contain",
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/images/no-image.png";
                          }}
                        />
                      ) : (
                        <p>No screenshot available.</p>
                      )}
                    </div>
                  </Col>
                  {/* <Col lg="3" md="6" sm="8" className="mb-4 justify-items-center mx-auto">
                    <Row className="justify-content-center flex-column px-3">
                      <Button
                        variant="none"
                        type="button"
                        className="vs-button-css mb-4 refer-btn1-font"
                        size="md"
                        onClick={() => handleModal("awesome")}
                      >
                        Awesome !
                        Like to refer my friends to this url
                      </Button>
                      <Button
                        type="button"
                        className="vs-button-css refer-btn2-font"
                        size="md"
                        onClick={() => handleModal("fix-wish")}
                      >
                        I would like to fix this vulnerability issues
                      </Button>
                    </Row>
                  </Col> */}
                </Row>
                <div className="row">
                  <div className="col">
                    <h3 className="heading-margin heading-font">Analysis</h3>
                    {scanData?.analysis ? (
                      scanData?.analysis.split("\n").map((item, index) =>
                        item ? (
                          <p key={index} className="analysis-item">
                            <span className="severity">
                              {item.split(":")[0]}:
                            </span>{" "}
                            <span className="description">
                              {item.split(":")[1]}
                            </span>
                          </p>
                        ) : null
                      )
                    ) : (
                      <p>No analysis available.</p>
                    )}
                  </div>
                </div>
                <div className="row mt-4 mb-4">
                  <div className="col">
                    <h3 className="heading-margin heading-font mt-2">
                      Remediation Suggestions
                    </h3>
                    {scanData?.remediations ? (
                      scanData?.remediations
                        .split("\n")
                        .map((remediation, index) =>
                          remediation ? (
                            <p key={index} className="remediation-item">
                              {remediation}
                            </p>
                          ) : null
                        )
                    ) : (
                      <p>No remediation suggestions available.</p>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <div className="text-center">
                <p>No audit report available. Please run a scan first.</p>
                <Button
                  type="submit"
                  className="vs-button-css"
                  size="md"
                  onClick={() => history.push("/")}
                >
                  Go Back
                </Button>
              </div>
            )}
          </div>
          <Suspense>
            <ReportModal
              show={showModal}
              source={buttonFlag}
              handleClose={() => setShowModal(false)}
              lastId={scanData?.scan_id}
              websiteURL={scanData?.url}
            />
            <SuccessModal
              show={showSuccessModal}
              modalData={modalData}
              handleClose={() => setShowSuccessModal(false)}
              performFunction={() => setShowSuccessModal(false)}
            />
          </Suspense>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  contactDetails: state.scan.contactDetails,
});

export default connect(mapStateToProps, { storeContact })(AuditReport);
